import {
  AccessDeniedError,
  BadRequestError,
  ConnectionError,
  HttpTypes,
  InternalServerError,
  TooManyRequestsError,
  UnexpectedError,
} from 'src/http';
import { httpResponseHandler } from 'src/http/http-response-handler';
import { endpoints } from 'src/utils/axios';
import { Either } from 'src/utils/either';

export class MissionsRepository {
  constructor(private api: HttpTypes.HttpClient) {}

  async getMissionsList(): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.missions.list,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getMissionDetails(
    id: string
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.missions.details(id),
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async createMission(
    mission: any
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: endpoints.missions.create,
      body: mission,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async updateMission(
    mission: any
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'put',
      url: endpoints.missions.update,
      body: mission,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }
}
